import html2canvas from "html2canvas";

import { ILog } from "../../../../Lib/Log/types";
import { IMapLayerSnapshotGenerator } from "../../snapshotGenerator";


export interface ILeafletTileLayerSnapshotGeneratorOptions {
  type?: string,    //Default: "image/png"
  quality?: number  //Default: browser default
}

export class LeafletSnapshotGenerator implements IMapLayerSnapshotGenerator {

  private readonly _options: ILeafletTileLayerSnapshotGeneratorOptions;
  private readonly _log: ILog;
  private _map: L.Map | null = null;

  constructor (options: ILeafletTileLayerSnapshotGeneratorOptions, log: ILog) {
    this._options = options;
    this._log = log;
  }

  public setMap = (map: L.Map) => {
    this._map = map;
  }

  public generate = (maxWidthPx?: number | null, maxHeightPx?: number | null): Promise<string> => {

      if (!this._map)
        throw Error('Unable to generate snapshot, init has not been called');

      return new Promise((resolve, reject) => {

      html2canvas(this._map?.getContainer()!, {
        logging: false,
        removeContainer: true
      })
        .then(canvas => {
          const resizedCanvas = LeafletSnapshotGenerator.fitImage(canvas, maxWidthPx ?? canvas.width, maxHeightPx ?? canvas.height);

          const dataUrl = resizedCanvas.toDataURL(this._options.type, this._options.quality);

          resolve(dataUrl);
        })
        .catch((error) => {
          this._log.error("LeafletSnapshotGenerator. Failed to generate map snapshot.", error);
          reject(error);
        })

      });
  }

  private static fitImage = (sourceCanvas: HTMLCanvasElement, maxWidth: number, maxHeight: number): HTMLCanvasElement => {

    const hRatio = maxWidth / sourceCanvas.width;
    const vRatio = maxHeight / sourceCanvas.height;
    var ratio  = Math.min(hRatio, vRatio);

    const destWidth = sourceCanvas.width * ratio;
    const destHeight = sourceCanvas.height * ratio;

    var destCanvas = document.createElement('canvas');
    destCanvas.width = destWidth;
    destCanvas.height = destHeight;

    var destCtx = destCanvas.getContext('2d');

    destCtx!.drawImage(sourceCanvas, 0,0, sourceCanvas.width, sourceCanvas.height, 0, 0, destWidth, destHeight);

    return destCanvas;
  }
}